import { usePricingDisplayQuote } from '@/hooks/usePricingDisplay';
import { supabase } from '@/integrations/supabase/client';
import { seekSupabase } from '@/integrations/supabase/seekClient';
import { validateCreditCartPricingQuote } from '@/lib/billing/pricingDisplay';

type Platform = 'forkhire' | 'forkseek';

export function useCreditCartPricing(
  platform: Platform,
  items: Array<{ packId: string; quantity: number }>,
) {
  const request = items.length
    ? {
        mode: 'credit_cart',
        credit_items: items.map((item) => ({
          pack_id: item.packId,
          quantity: item.quantity,
        })),
      }
    : null;
  const client = platform === 'forkseek' ? seekSupabase : supabase;
  const query = usePricingDisplayQuote(client, platform, request);
  return {
    ...query,
    ...validateCreditCartPricingQuote(items, query.data, {
      isLoading: query.isLoading || query.isFetching,
      isError: query.isError,
    }),
  };
}
